import Swiper, { EffectFade, Lazy, Navigation } from "swiper";

class Gallery {
  wrapper = null;

  constructor(el) {
    this.wrapper = $(el);

    if (this.wrapper.length) {
      this.init();
    }
  }

  init() {
    new Swiper(this.wrapper.children(".swiper")[0], {
      modules: [EffectFade, Lazy, Navigation],
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },

      navigation: {
        nextEl: this.wrapper.find(".swiper-nav--next")[0],
        prevEl: this.wrapper.find(".swiper-nav--prev")[0],
      },
    });
  }
}

export default Gallery;
